export default str => {
    let el = document.createElement('textarea');
    el.value = str;
    el.readOnly = true;
    el.style.position = 'absolute';
    el.style.left = '-9999px';

    document.body.appendChild(el);
    el.select();

    document.execCommand('copy');
    document.body.removeChild(el);
}